import React from 'react';
import styles from './SectionHeading.module.css';

const SectionHeading = ({eyebrow, title, text, align = 'left'}) => (
    <div className={`${styles.heading} ${styles[align]}`}>
        {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
        <h2>{title}</h2>
        {text && <p className={styles.text}>{text}</p>}
    </div>
);

export default SectionHeading;
